import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { changeAddress } from '../../../actions/address';
import { FormField } from '../../../components/FormField';
import { GeoSuggest, useGeoSuggest } from '../../../components/GeoSuggest';
import { selectAddress, selectChangeAddressPending } from '../../../selectors/address';
import { TThunkDispatch } from '../../../types/redux/thunk';
import { TResultSuggestion } from '../../../types/suggest';

export const Address: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const address = useSelector(selectAddress);
  const changeAddressPending = useSelector(selectChangeAddressPending);
  const [value, setValue] = React.useState<string>('');
  const { suggestions, getSuggestions, getGeolocation, isLoading: isSuggestionsLoading } = useGeoSuggest();
  const isLoading = isSuggestionsLoading || changeAddressPending;

  const handleValueChange = useEventCallback((value: string) => {
    setValue(value);
    getSuggestions(value);
  });

  const handleItemSelect = React.useCallback(
    async (item: TResultSuggestion) => {
      dispatch(changeAddress(item));
    },
    [dispatch],
  );

  return (
    <FormField label="Где хотите жить?" data-name="AddressFormField">
      <GeoSuggest
        value={value}
        loading={isLoading}
        disabled={changeAddressPending}
        placeholder="Город, район, улица"
        selectedItem={address}
        suggestions={suggestions}
        onValueChange={handleValueChange}
        onItemSelect={handleItemSelect}
        onGetGeolocation={getGeolocation}
      />
    </FormField>
  );
};
